import appConstants from '../../../../../constants';
import { KEYS } from '../../../../../l18n/constants';
import { useL18nContext } from '../../../ContextProvider/L18n';
import computeClassName from "../../../../../utils/computeClassName";

const constants = Object.freeze({
  CLASSNAME_BASE: ''
});
export default function PartnerNameRoleAndLevelDescription(
  {
    name,
    role,
    level,
    className = ''
  }
  ) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { getTranslationFor } = useL18nContext();
  const translatedCiscoIsASentence = getTranslationFor(KEYS.L18N_KEY_LABEL_IS_A_CISCO);
  return (
    <section className={computedClassName}>
      <h3 className="text-cc-200 sm:text-cc-300 font-light mb-4">
        <span><span>{level}</span><span className="ml-cc-1char">{role}</span></span>
      </h3>
      <h4 className="text-cc-body-large font-normal mb-6">
        <span>
          <span>{name}</span><span className="ml-cc-1char">{translatedCiscoIsASentence}</span><span className="ml-cc-1char">{level}</span><span className="ml-cc-1char">{role}</span>
        </span>
      </h4>
      <p className="text-cc-body-medium sm:text-cc-body-large text-cc-secondary-contrast font-light">{getTranslationFor(appConstants.LABEL_ROLE_DESCRIPTION_MAPPING[role])}</p>
    </section>
  );
}
